import React, { useContext, useState, useEffect } from 'react'

import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'
import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { IntakeContext } from 'context/IntakeContext'
import Slide from '@mui/material/Slide'
import { toast } from 'react-toastify'
import { useFinances } from 'hooks/useFinances'
import Checkbox from '@mui/material/Checkbox'
import { selectData } from 'layouts/onboarding'
import { FormControlLabel, FormGroup } from '@mui/material'
import { useModal } from 'components/modals'
import { format, differenceInYears, addYears, addDays } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SelectInput = styled.select`
  display: flex;
  width: 100%;
  height: 2.5rem;
  font-size: 0.875rem;
  padding: 0 0.75rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid #d2d6da;
  color: #344767;
  letter-spacing: 0.00938em;
  font-family: Roboto;
  cursor: pointer;
  text-transform: capitalize;
  margin-top: 3px;
  &:active,
  &:focus,
  &:focus-visible {
    border-color: #17c1e8;
    box-shadow: 0 0 0 0.125rem rgba(129, 227, 249);
  }
`

export const NewBalanceSheetModalForm = ({
  canEdit,
  handleClose,
  handleResetForm,
  type,
  subType,
  name,
  amount,
  setSubType,
  setType,
  setName,
  setAmount,
  open,
  subTypeClassification,
  setSubTypeClassification,
  interestRate,
  setInterestRate,
  handleSubmit,
  typeSubTypeUuid,
  setKeepInRetirement,
  keepInRetirement,
  setMonthlyPayment,
  monthlyPayment,
  frequency,
  setFrequency,
  ieStartDate,
  setIeStartDate,
  policyNumber,
  setPolicyNumber,
  balance,
  loanEndDate,
  setLoanEndDate,
  issueDate,
  setIssueDate,
  carrier,
  setCarrier,
  product,
  setProduct,
  anniversaryDate,
  signalLinked,
  reloadAccounts,
  // subTypeOptions = [],
  hideName,
  plaidName,
  modalHeader,
  newStyle = false,
  isAdmin = false,
  signalForm = false,
  signalError = false,
}) => {
  const { intakeState } = useContext(IntakeContext)
  const { createOrUpdateAccount, deleteAccount } = useFinances()
  const checked = keepInRetirement || false
  const { openModal } = useModal()
  const [subTypeOptions, setSubTypeOptions] = useState([])
  const { deductionTypes } = selectData

  // console.log(type)
  // console.log(subType)
  // console.log(setKeepInRetirement)
  // console.log(keepInRetirement)
  // console.log(name)
  // console.log(amount)
  // console.log(subTypeOptions)

  useEffect(() => {
    if (type === 'deduction') {
      setSubTypeOptions(deductionTypes)
    }
  }, [type, deductionTypes])

  const onSubmit = async (addAnother = false) => {
    await createOrUpdateAccount({
      name,
      amount,
      type,
      subType,
      subTypeClassification,
      interestRate,
      typeSubTypeUuid,
      keepInRetirement,
      loanEndDate,
      monthlyPayment,
      frequency,
      ieStartDate,
      policyNumber,
      balance,
      issueDate,
      carrier,
      product,
      anniversaryDate,
      signalLinked,
    })
    toast.info(
      `You have successfully ${
        typeSubTypeUuid ? 'updated' : 'created'
      }: ${name}`,
      {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
    reloadAccounts()

    if (addAnother) {
      handleResetForm()
    } else {
      handleClose()
    }
  }

  // const onDoubleSubmit = async ({
  //   secondType = 'income',
  //   secondSubType = 'annuity',
  // }) => {
  //   const linkedAccountId = uuidv4()
  //   const incomeExpenseMapping = ''
  //   // asset
  //   await createOrUpdateAccount({
  //     name,
  //     amount: secondSubType === 'annuity' ? balance : amount,
  //     type,
  //     subType,
  //     subTypeClassification,
  //     interestRate,
  //     typeSubTypeUuid,
  //     loanEndDate,
  //     monthlyPayment,
  //     frequency,
  //     ieStartDate,
  //     policyNumber,
  //     issueDate,
  //     carrier,
  //     product,
  //     anniversaryDate,
  //     signalLinked,
  //     linkedAccountId,
  //   })
  //   toast.info(`You have successfully created Asset: ${name}`, {
  //     position: 'top-center',
  //     autoClose: 5000,
  //     pauseOnFocusLoss: false,
  //     pauseOnHover: false,
  //   })
  //   // income stream
  //   await createOrUpdateAccount({
  //     name,
  //     amount: type === 'liability' ? monthlyPayment : amount,
  //     type: secondType,
  //     subType: secondSubType,
  //     typeSubTypeUuid,
  //     frequency,
  //     ieStartDate,
  //     balance,
  //     issueDate,
  //     carrier,
  //     product,
  //     anniversaryDate,
  //     linkedAccountId,
  //   })
  //   // toast.info(`You have successfully created Income: ${name}`, {
  //   //   position: 'top-center',
  //   //   autoClose: 5000,
  //   //   pauseOnFocusLoss: false,
  //   //   pauseOnHover: false,
  //   // })
  //   reloadAccounts()
  //   handleClose()
  // }

  const onDelete = async () => {
    await deleteAccount({ typeSubTypeUuid })
    toast.info(`You have successfully deleted account "${name}"`)
    reloadAccounts()
    handleSubmit()
  }
  // console.log(dateOfBirth)
  const dateOfBirth = intakeState?.dateOfBirth || new Date()
  const [yearsRemaining, setYearsRemaining] = useState(true)
  const [alreadyCollecting, setAlreadyCollecting] = useState(false)
  const [incomeAge, setIncomeAge] = useState(true)
  const [incomeStartSelection, setIncomeStartSelection] =
    useState('specificAge')
  const dateToYears = loanEndDate
    ? differenceInYears(addDays(new Date(loanEndDate), 2), new Date())
    : null
  const yearsToDate = (years) =>
    format(addYears(new Date(), years), 'yyyy-MM-dd')
  const ageToYears = ieStartDate
    ? differenceInYears(
        addDays(new Date(ieStartDate), 2),
        new Date(dateOfBirth)
      )
    : null
  const yearsToAge = (years) =>
    format(addYears(new Date(dateOfBirth), years), 'yyyy-MM-dd')

  const setDeductionName = (selection) => {
    setSubType(selection)
    setName(
      subTypeOptions.find(({ value }) => value === selection)?.label || ''
    )
  }

  const setIncomeExpenseName = (selection) => {
    setSubType(selection)
    setName(
      selectData.balanceSheetSubType.find(({ value }) => value === selection)
        ?.label || ''
    )
  }

  const setNameWithClassification = (selection) => {
    setSubTypeClassification(selection)
    setName(
      selectData.balanceSheetSubTypeClassification.find(
        ({ value }) => value === selection
      )?.label || ''
    )
  }

  const setCategoryWithLogic = (category) => {
    setSubType(category)
    const categoryMap = {
      property: {
        classification: 'primaryresidence',
        name: 'Primary Residence',
      },
      mortgage: {
        classification: 'primarymortgage',
        name: 'Primary Mortgage',
      },
      checkingsavings: {
        classification: 'checkingaccount',
        name: 'Checking Account',
      },
      creditcard: {
        classification: 'creditcard',
        name: 'Credit Card',
      },
      autoloan: {
        classification: 'auto',
        name: 'Auto Loan',
      },
    }

    const selected = categoryMap[category] || { classification: '', name: '' }

    setSubTypeClassification(selected.classification)
    setName(selected.name)
  }

  const filteredProducts = selectData.annuityOptions.filter(
    (option) => option.provider === carrier
    // (option) => option.provider === localForm?.carrier && option.isMapped
  )

  // Auto select the Already Collecting Box if date is prior to today
  useEffect(() => {
    if (ieStartDate) {
      const startDate = new Date(ieStartDate)
      const today = new Date()

      // Normalize both to midnight to compare only dates (not times)
      startDate.setHours(0, 0, 0, 0)
      today.setHours(0, 0, 0, 0)

      if (startDate <= today) {
        setAlreadyCollecting(true)
      }
    }
  }, [ieStartDate])

  return (
    <Grid item xs={12} data-testid="balanceSheetModal">
      {subType === 'annuity' || subTypeClassification === 'annuity' ? (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          mb={3}
          mt={{ xs: '16px', md: '-16px' }}
        >
          {signalForm || signalLinked ? (
            <>
              <Grid item xs={12}>
                <Box sx={{ marginTop: 1 }}>
                  <Typography variant="body1Medium">
                    Linked Annuity Details
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  label: 'Carrier',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: carrier,
                  onChange: (e) => {
                    setCarrier(e)
                    setName(
                      `${
                        selectData.annuityCarriers.find(
                          ({ value }) => value === e
                        )?.label || ''
                      } - ${
                        selectData.annuityOptions.find(
                          ({ value }) => value === product
                        )?.label || ''
                      }`
                    )
                  },
                  options: selectData.annuityCarriers,
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  label: 'Product',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: product,
                  onChange: (e) => {
                    setProduct(e)
                    setName(
                      `${
                        selectData.annuityCarriers.find(
                          ({ value }) => value === carrier
                        )?.label || ''
                      } - ${
                        selectData.annuityOptions.find(
                          ({ value }) => value === e
                        )?.label || ''
                      }`
                    )
                  },
                  options: filteredProducts,
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'currencyFloat',
                  placeholder: '$XX,XXX.XX',
                  label: 'Account Value',
                  value: amount,
                  onChange: setAmount,
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'date',
                  placeholder: 'MM/DD/YYYY',
                  label: `Issued Date`,
                  value: issueDate,
                  onChange: (e) => setIssueDate(e),
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'date',
                  placeholder: 'MM/DD/YYYY',
                  label: `Anniversary Date`,
                  value: anniversaryDate,
                  onChange: (e) => setAnniversaryDate(e),
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid> */}
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'text',
                  placeholder: 'Policy Number',
                  label: `Policy Number`,
                  value: policyNumber,
                  onChange: setPolicyNumber,
                  disabled: true,
                  className: 'linkedDisabled',
                })}
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ marginTop: { xs: 1, md: 2 } }}>
                  <Typography variant="body1Medium">
                    Annuity Income Details
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'currencyFloat',
                  placeholder: '$XX,XXX.XX',
                  label: 'Annuity Income Amount',
                  value: monthlyPayment,
                  onChange: (e) => {
                    setType('assetIncome')
                    setMonthlyPayment(e)
                  },
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'select',
                  placeholder: 'Monthly / Annual',
                  label: 'Income Frequency',
                  value: frequency,
                  onChange: setFrequency,
                  options: [
                    { value: 'monthly', label: 'Monthly' },
                    { value: 'annual', label: 'Annual' },
                  ],
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'select',
                  placeholder: 'When will income start?',
                  label: 'When will income start?',
                  value: incomeStartSelection,
                  onChange: (e) => {
                    setIncomeStartSelection(e)
                    e !== 'specificAge'
                      ? setIncomeAge(false)
                      : setIncomeAge(true)
                    e === 'uponRetirement'
                      ? setIeStartDate(intakeState?.dateOfPlannedRetirement)
                      : e === 'alreadyStarted'
                      ? setIeStartDate(yearsToDate(0))
                      : console.log('manually adjust date')
                  },
                  options: [
                    { value: 'uponRetirement', label: 'Upon Retirement' },
                    { value: 'specificAge', label: 'Specific Age' },
                    { value: 'specificDate', label: 'Specific Date' },
                    { value: 'alreadyStarted', label: 'Already Started' },
                  ],
                })}
              </Grid>
              {incomeAge ? (
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    inputType: 'int',
                    placeholder: '',
                    label: `Income Start Age`,
                    value: ageToYears,
                    onChange: (e) => {
                      setIeStartDate(yearsToAge(e))
                    },
                  })}
                </Grid>
              ) : (
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    inputType: 'date',
                    placeholder: 'MM/DD/YYYY',
                    label: `Income Start Date`,
                    value: ieStartDate,
                    onChange: (e) => setIeStartDate(e),
                  })}
                </Grid>
              )}
            </>
          ) : (
            <>
              {signalError && (
                <Grid item xs={12}>
                  <Typography variant="body1" color="error">
                    Failed to fetch policy information. Please check your policy
                    number and try again or enter details manually below:
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box sx={{ marginTop: 1 }}>
                  <Typography variant="body1Medium">
                    Annuity Asset Details
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  label: 'Carrier',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: carrier,
                  onChange: (e) => {
                    setCarrier(e)
                    setName(
                      `${
                        selectData.annuityCarriers.find(
                          ({ value }) => value === e
                        )?.label || ''
                      } - ${
                        selectData.annuityOptions.find(
                          ({ value }) => value === product
                        )?.label || ''
                      }`
                    )
                  },
                  options: selectData.annuityCarriers,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  label: 'Product',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: product,
                  onChange: (e) => {
                    setProduct(e)
                    setName(
                      `${
                        selectData.annuityCarriers.find(
                          ({ value }) => value === carrier
                        )?.label || ''
                      } - ${
                        selectData.annuityOptions.find(
                          ({ value }) => value === e
                        )?.label || ''
                      }`
                    )
                  },
                  options: filteredProducts,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'currencyFloat',
                  placeholder: '$XX,XXX.XX',
                  label: 'Annuity Account Value',
                  value: amount,
                  onChange: setAmount,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'date',
                  placeholder: 'MM/DD/YYYY',
                  label: `Issued Date`,
                  value: issueDate,
                  onChange: (e) => setIssueDate(e),
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'text',
                  placeholder: 'Policy Number',
                  label: `Policy Number`,
                  value: policyNumber,
                  onChange: setPolicyNumber,
                })}
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'date',
                  placeholder: 'MM/DD/YYYY',
                  label: `Anniversary Date`,
                  value: anniversaryDate,
                  onChange: (e) => setAnniversaryDate(e),
                })}
              </Grid> */}
              <Grid item xs={12}>
                <Box sx={{ marginTop: 1 }}>
                  <Typography variant="body1Medium">
                    Annuity Income Details
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'currencyFloat',
                  placeholder: '$XX,XXX.XX',
                  label: 'Annuity Income Amount',
                  value: monthlyPayment,
                  onChange: (e) => {
                    setType('assetIncome')
                    setMonthlyPayment(e)
                  },
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'select',
                  placeholder: 'Monthly / Annual',
                  label: 'Income Frequency',
                  value: frequency,
                  onChange: setFrequency,
                  options: [
                    { value: 'monthly', label: 'Monthly' },
                    { value: 'annual', label: 'Annual' },
                  ],
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'select',
                  placeholder: 'When will income start?',
                  label: 'When will income start?',
                  value: incomeStartSelection,
                  onChange: (e) => {
                    setIncomeStartSelection(e)
                    e !== 'specificAge'
                      ? setIncomeAge(false)
                      : setIncomeAge(true)
                    e === 'uponRetirement'
                      ? setIeStartDate(intakeState?.dateOfPlannedRetirement)
                      : e === 'alreadyStarted'
                      ? setIeStartDate(yearsToDate(0))
                      : console.log('manually adjust date')
                  },
                  options: [
                    { value: 'uponRetirement', label: 'Upon Retirement' },
                    { value: 'specificAge', label: 'Specific Age' },
                    { value: 'specificDate', label: 'Specific Date' },
                    { value: 'alreadyStarted', label: 'Already Started' },
                  ],
                })}
              </Grid>
              {incomeAge ? (
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    inputType: 'int',
                    placeholder: '',
                    label: `Income Start Age`,
                    value: ageToYears,
                    onChange: (e) => {
                      setIeStartDate(yearsToAge(e))
                    },
                  })}
                </Grid>
              ) : (
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    inputType: 'date',
                    placeholder: 'MM/DD/YYYY',
                    label: `Income Start Date`,
                    value: ieStartDate,
                    onChange: (e) => setIeStartDate(e),
                  })}
                </Grid>
              )}
            </>
          )}
        </Grid>
      ) : subTypeClassification === 'rentalproperty' ||
        subType === 'rentalincome' ? (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          mb={3}
          mt={{ xs: '16px', md: '-16px' }}
        >
          <Grid item xs={12}>
            <Box sx={{ marginTop: 1 }}>
              <Typography variant="body1Medium">
                Rental Property Details
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderMuiFormField({
              inputType: 'text',
              placeholder: 'Property Name',
              label: 'Property Name',
              value: name,
              onChange: setName,
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderMuiFormField({
              inputType: 'currencyFloat',
              placeholder: '$XX,XXX.XX',
              label: 'Property Value',
              value: amount,
              onChange: setAmount,
            })}
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ marginTop: 1 }}>
              <Typography variant="body1Medium">
                Rental Income Details
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            {renderMuiFormField({
              inputType: 'currencyFloat',
              placeholder: '$XX,XXX.XX',
              label: 'Income Amount',
              value: monthlyPayment,
              onChange: (e) => {
                setType('assetIncome')
                setMonthlyPayment(e)
              },
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderMuiFormField({
              inputType: 'select',
              placeholder: 'Monthly / Annual',
              label: 'Income Frequency',
              value: frequency,
              onChange: setFrequency,
              options: [
                { value: 'monthly', label: 'Monthly' },
                { value: 'annual', label: 'Annual' },
              ],
            })}
          </Grid>
          <Grid xs={12} sm={6}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="left"
              style={{ margin: '16px', marginLeft: '40px' }}
            >
              <FormControlLabel
                label="Already Collecting?"
                sx={{
                  '> span': {
                    fontWeight: 'normal !important',
                    fontSize: '1rem',
                  },
                }}
                control={
                  <Checkbox
                    name="alreadyCollecting"
                    onChange={(e) => {
                      e.target.checked
                        ? setIeStartDate(yearsToDate(0))
                        : setIeStartDate('')
                      setAlreadyCollecting(e.target.checked)
                    }}
                    checked={alreadyCollecting}
                  />
                }
              ></FormControlLabel>
            </Box>
          </Grid>
          {incomeAge ? (
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                inputType: 'int',
                placeholder: '',
                label: `Income Start Age`,
                value: ageToYears,
                onChange: (e) => {
                  setIeStartDate(yearsToAge(e))
                },
              })}
              <Box display="flex" justifyContent="flex-start">
                <Button
                  variant="text"
                  color="info"
                  sx={{
                    color: '#2370ED',
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      color: '#2370ED',
                    },
                  }}
                  onClick={() => setIncomeAge(false)}
                >
                  Use Starting Date Instead
                </Button>
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                inputType: 'date',
                placeholder: 'MM/DD/YYYY',
                label: `Income Start Date`,
                value: ieStartDate,
                onChange: (e) => setIeStartDate(e),
              })}
              <Box display="flex" justifyContent="flex-start">
                <Button
                  variant="text"
                  color="info"
                  sx={{
                    color: '#2370ED',
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      color: '#2370ED',
                    },
                  }}
                  onClick={() => setIncomeAge(true)}
                >
                  Use Starting Age Instead
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      ) : (
        <>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            mb={3}
            mt={{ xs: '16px', md: '-16px' }}
          >
            <Grid item xs={12} sm={6} sx={{ display: 'none' }}>
              <Typography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Select Type
              </Typography>
              <SelectInput
                name="type"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="asset">Asset</option>
                <option value="liability">Liability</option>
              </SelectInput>
            </Grid>
            {/* Asset/Liability or Deduction */}
            {subTypeOptions.length ? (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  label: 'Select Type',
                  placeholder: '',
                  inputType: 'select',
                  value: subType,
                  onChange: (e) => setDeductionName(e),
                  options: subTypeOptions,
                })}
              </Grid>
            ) : (
              <>
                {type !== 'asset' &&
                  type !== 'liability' &&
                  subType?.toLowerCase().includes('other') && (
                    <Grid item xs={12} sm={6}>
                      {renderMuiFormField({
                        autoFocus: false,
                        label: 'Select Category',
                        placeholder: '',
                        inputType: 'select',
                        value: subType,
                        onChange: (e) =>
                          type === 'income' || type === 'expense'
                            ? setIncomeExpenseName(e)
                            : setCategoryWithLogic(e),
                        options: selectData.balanceSheetSubType,
                        optionMatchValue: type,
                        optionMatchProp: 'subType',
                      })}
                    </Grid>
                  )}
                {type !== 'income' && type !== 'expense' ? (
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      autoFocus: false,
                      label: 'Select Type',
                      placeholder: '',
                      inputType: 'select',
                      value: subTypeClassification,
                      onChange: (e) => setNameWithClassification(e),
                      options: selectData.balanceSheetSubTypeClassification,
                      optionMatchValue: subType,
                      optionMatchProp: 'listToAppear',
                    })}
                  </Grid>
                ) : (
                  // include spacer if we want to show the category selection
                  subType?.toLowerCase().includes('other') && (
                    <Grid item xs={12} sm={6}></Grid>
                  )
                )}
              </>
            )}
            {type === 'deduction' ? null : (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'text',
                  placeholder: '',
                  label: 'Name',
                  value: name,
                  onChange: setName,
                })}
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                inputType: 'currencyFloat',
                placeholder: '$XX,XXX.XX',
                label:
                  type === 'liability'
                    ? 'Remaining Balance'
                    : type === 'deduction'
                    ? 'Amount Per Pay Period'
                    : type === 'income'
                    ? 'Income Amount'
                    : type === 'expense'
                    ? 'Expense Amount'
                    : 'Amount',
                value: amount,
                onChange: setAmount,
              })}
            </Grid>
            {type === 'liability' ? (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'percentage',
                  placeholder: 'Ex. 15.0%',
                  label: 'Interest Rate',
                  value: interestRate,
                  onChange: setInterestRate,
                })}
              </Grid>
            ) : null}
            {type === 'liability' && (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  inputType: 'currencyFloat',
                  placeholder: '$XX,XXX.XX',
                  label:
                    subType === 'tspLoan'
                      ? 'Bi-weekly Payment'
                      : 'Monthly Payment',
                  value: monthlyPayment,
                  onChange: setMonthlyPayment,
                })}
              </Grid>
            )}
            {type === 'liability' && (
              <>
                {!yearsRemaining ? (
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      inputType: 'date',
                      placeholder: 'MM/DD/YYYY',
                      label: 'Loan End Date',
                      value: loanEndDate,
                      onChange: (e) => setLoanEndDate(e),
                    })}
                    <Box display="flex" justifyContent="flex-start">
                      <Button
                        variant="text"
                        color="info"
                        sx={{
                          color: '#2370ED',
                          '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                            color: '#2370ED',
                          },
                        }}
                        onClick={() => setYearsRemaining(false)}
                      >
                        Use Years Remaining Instead
                      </Button>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      inputType: 'int',
                      placeholder: '',
                      label: 'Years Remaining on Loan',
                      value: dateToYears,
                      onChange: (e) => {
                        setLoanEndDate(yearsToDate(e))
                      },
                    })}
                    <Box display="flex" justifyContent="flex-start">
                      <Button
                        variant="text"
                        color="info"
                        sx={{
                          color: '#2370ED',
                          '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                            color: '#2370ED',
                          },
                        }}
                        onClick={() => setYearsRemaining(true)}
                      >
                        Use Loan End Date
                      </Button>
                    </Box>

                    {/* <Box display="flex">
                    <Button
                      variant="parcoRounded"
                      size="small"
                      color="secondary"
                      onClick={() => setLoanEndDate(yearsToDate(5))}
                    >
                      5 Year
                    </Button>
                    <Button
                      variant="parcoRounded"
                      size="small"
                      color="secondary"
                      sx={{ marginLeft: '5px' }}
                      onClick={() => setLoanEndDate(yearsToDate(10))}
                    >
                      10 Year
                    </Button>
                    <Button
                      variant="parcoRounded"
                      size="small"
                      color="secondary"
                      sx={{ marginLeft: '5px' }}
                      onClick={() => setLoanEndDate(yearsToDate(15))}
                    >
                      15 Year
                    </Button>
                    <Button
                      variant="parcoRounded"
                      size="small"
                      color="secondary"
                      sx={{ marginLeft: '5px' }}
                      onClick={() => setLoanEndDate(yearsToDate(30))}
                    >
                      30 Year
                    </Button>
                  </Box> */}
                  </Grid>
                )}
              </>
            )}
            {(type === 'income' || type === 'expense') && (
              <>
                {yearsRemaining ? (
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      inputType: 'date',
                      placeholder: 'MM/DD/YYYY',
                      label: `${
                        type.charAt(0).toUpperCase() + type.slice(1)
                      } Start Date`,
                      value: ieStartDate,
                      onChange: (e) => setIeStartDate(e),
                    })}
                    <Box display="flex" justifyContent="flex-start">
                      <Button
                        variant="text"
                        color="info"
                        sx={{
                          color: '#2370ED',
                          '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                            color: '#2370ED',
                          },
                        }}
                        onClick={() => setYearsRemaining(false)}
                      >
                        Use Starting Age Instead
                      </Button>
                    </Box>
                    <Box display="flex" mt={1}>
                      <Button
                        variant="parcoRounded"
                        size="small"
                        color="secondary"
                        onClick={() => setIeStartDate(yearsToDate(0))}
                      >
                        Make Active Today
                      </Button>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      inputType: 'int',
                      placeholder: '',
                      label: `${
                        type.charAt(0).toUpperCase() + type.slice(1)
                      } Starting Age`,
                      value: ageToYears,
                      onChange: (e) => {
                        setIeStartDate(yearsToAge(e))
                      },
                    })}
                    <Box display="flex" justifyContent="flex-start">
                      <Button
                        variant="text"
                        color="info"
                        sx={{
                          color: '#2370ED',
                          '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                            color: '#2370ED',
                          },
                        }}
                        onClick={() => setYearsRemaining(true)}
                      >
                        Use Starting Date Instead
                      </Button>
                    </Box>
                    <Box display="flex" mt={1}>
                      <Button
                        variant="parcoRounded"
                        size="small"
                        color="secondary"
                        onClick={() => setIeStartDate(yearsToDate(0))}
                      >
                        Make Active Today
                      </Button>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    inputType: 'select',
                    placeholder: 'Monthly / Annual',
                    label: 'Frequency',
                    value: frequency,
                    onChange: setFrequency,
                    options: [
                      { value: 'monthly', label: 'Monthly' },
                      { value: 'annual', label: 'Annual' },
                    ],
                  })}
                </Grid>
              </>
            )}
          </Grid>
          {type === 'deduction' &&
            setKeepInRetirement &&
            subType !== 'charity' &&
            subType !== 'fsa' &&
            subType !== 'hsa' &&
            subType !== 'alotsavings' &&
            subType !== 'alotchecking' &&
            subType !== 'alotother' && (
              <Grid>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="left"
                  height="100%"
                  style={{ margin: '10px' }}
                >
                  <FormControlLabel
                    label="Keep in Retirement?"
                    sx={{
                      '> span': {
                        fontWeight: 'normal !important',
                        fontSize: '1rem',
                      },
                    }}
                    control={
                      <Checkbox
                        name="keepInRetirement"
                        onChange={(e) => setKeepInRetirement(e.target.checked)}
                        checked={checked}
                      />
                    }
                  ></FormControlLabel>
                </Box>
              </Grid>
            )}
        </>
      )}

      <Box
        display={'flex'}
        flexDirection="row"
        justifyContent="space-between"
        mt={{ xs: 1, md: 5 }}
      >
        <Box>
          <Button onClick={handleClose} variant="parcoRounded" color="outline">
            Cancel
          </Button>
        </Box>
        <Box
          sx={{
            justifyContent: 'center',
          }}
        >
          {canEdit && (
            <Button
              variant="parcoRounded"
              color="outlineError"
              onClick={() => {
                openModal('fallbackModal', {
                  title: 'Delete this account?',
                  content: (
                    <>
                      Your account <strong>{name}</strong> will be removed from
                      your profile.
                    </>
                  ),
                  buttonText: 'Delete Account',
                  buttonColor: '#FF2F32',
                  buttonHoverColor: '#cc2528',
                  cancelButtonText: 'Keep it',
                  actionOverride: onDelete,
                })
              }}
            >
              Delete
            </Button>
          )}
          {!canEdit && isAdmin && (
            <Button variant="parcoRounded" onClick={() => onSubmit(true)}>
              Save & Add Another
            </Button>
          )}
          <Button
            variant="parcoRounded"
            onClick={() => {
              !canEdit && isAdmin
                ? onSubmit(false)
                : // (subType === 'annuity' || subTypeClassification === 'annuity')
                  //   ? onDoubleSubmit({
                  //       secondType: 'income',
                  //       secondSubType: 'annuity',
                  //     })
                  //   : !canEdit && isAdmin && type === 'liability' && monthlyPayment
                  //   ? subType === 'mortgage'
                  //     ? onDoubleSubmit({
                  //         secondType: 'expense',
                  //         secondSubType: 'primarymortgage',
                  //       })
                  //     : subType === 'creditcard'
                  //     ? onDoubleSubmit({
                  //         secondType: 'expense',
                  //         secondSubType: 'creditcard',
                  //       })
                  //     : onDoubleSubmit({
                  //         secondType: 'expense',
                  //         secondSubType: subType,
                  //       })
                  onSubmit(false)
            }}
            sx={{ marginLeft: '16px' }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Grid>
  )
}
